import * as Constantes from "./constantes";

import { v4 as uuidv4 } from 'uuid';

export const obtenerMensajeError = (codigoError) => {
    let mensaje = Constantes['MENSAJE_ERROR_SERVICIO_' + codigoError]
    if(mensaje === undefined || mensaje === null) {
        mensaje = Constantes.MENSAJE_ERROR_SERVICIO_GENERICO
    }
    return mensaje
}

export const obtenerMensajeError2 = (codigoError, dataJson) => {
    let mensaje = Constantes['MENSAJE_ERROR_SERVICIO_' + codigoError]
    if(mensaje === undefined || mensaje === null) {
        mensaje = Constantes.MENSAJE_ERROR_SERVICIO_GENERICO
    }
    if(dataJson.data && dataJson.data.includes('Error frecuencia de pago')){
        mensaje = 'La cotización seleccionada hace referencia a un producto de Prima Única que debe tener Frecuencia de Pago Anual. Revisar la Cotización.'
    }
    return mensaje
}

export const procesarRespuesta = async (options) => {
    let response = null
    let respuesta = {
        auditResponse: {
            codigoRespuesta: '001',
            mensajeRespuesta: 'Ejecucion incorrecta'
        }
    }

    try {
        response = await fetch(options.url, options)
        if(response.ok) {
            const json = await response.json();
            if(json.auditResponse === undefined) {
                let entity = (options.sendAuthorization !== undefined && options.sendAuthorization === true
                    ? response.headers.get("authorization")
                    : (json.entity !== undefined ? json.entity : json))
                respuesta = {
                    entity: entity,
                    auditResponse: {
                        codigoRespuesta: '0',
                        mensajeRespuesta: 'Ejecucion correcta'
                    }
                }
            } else {
                respuesta = json
            }
        } else {
            const json = await response.json();
            if(json.auditResponse !== undefined) {
                respuesta = {
                    auditResponse: {
                        ...json.auditResponse,
                        detalle: {
                            status: response.status,
                            statusText: response.statusText,
                            type: response.type,
                            renovarToken: response.status === 401 && response.headers.get('ErrorReason') === 'TokenExpired'
                        }
                    }
                }
            } else {
                respuesta = {
                    auditResponse: {
                        codigoRespuesta: response.status,
                        mensajeRespuesta: response.status === 403 || response.status === 400 ? json.message 
                            : obtenerMensajeError2(response.status, json),
                        detalle: {
                            status: response.status,
                            statusText: response.statusText,
                            type: response.type,
                            renovarToken: response.status === 401
                        }
                    }
                }
            }
        }
    } catch (error) {
        if(response !== undefined && response !== null) {
            respuesta = {
                auditResponse: {
                    codigoRespuesta: response.status,
                    mensajeRespuesta: obtenerMensajeError(response.status),
                    detalle: {
                        status: response.status,
                        statusText: response.statusText,
                        type: response.type,
                        renovarToken: response.status === 401 && response.headers.get('ErrorReason') === 'TokenExpired'
                    }
                }
            }
        }
    }

    return respuesta
}

export const procesarRespuestraCloud = async (options) => {
    try {
        const response = await fetch(options.url, options);
        
        if (response.ok) {
            if (isHaveResponse(response)) {
                const json = await response.json();
                return json;
            } else {
                return {};
            }
        } else {
            const json = isHaveResponse(response) ? await response.json() : {};
            return Promise.reject(json);
        }
    } catch (error) {
        console.error("Error in procesarRespuestraCloud:", error);
        return Promise.reject(error);
    }
};

const isHaveResponse = (response) => {
    let isResponseJson = true;
    const contentType = response.headers.get('Content-Type');
    if (!contentType || !contentType.includes('application/json')) {
        isResponseJson = false;
    }

    return isResponseJson;
}

// para los servicios adecuados
export const manejarRespuesta = async (options) => {
    let response;
    let respuesta = { auditResponse: { codigoRespuesta: '001', mensajeRespuesta: 'Ejecucion incorrecta' } };

    try {
        response = await fetch(options.url, options);
        const json = await response.json();

        if (response.ok) {
            respuesta = json.auditResponse !== undefined ? json : {
                entity: options.sendAuthorization ? response.headers.get('authorization') : json.entity ?? json,
                auditResponse: { codigoRespuesta: '0', mensajeRespuesta: 'Ejecucion correcta' }
            };
        } else {
            const hasAudit = json.auditResponse !== undefined;
            const renovarToken = hasAudit ? 
                response.codigo === 401 && response.headers.get('ErrorReason') === 'TokenExpired' : 
                response.codigo === 401;
            
            const detalle = { 
                codigo: response.codigo, 
                tipo: response.tipo, 
                renovarToken 
            };

            respuesta = hasAudit ? 
                { auditResponse: { ...json.auditResponse, detalle } } : 
                { auditResponse: { 
                    codigoRespuesta: response.codigo,
                    mensajeRespuesta: [403, 400].includes(response.codigo) ? json.data : obtenerMensajeError(response.codigo),
                    detalle 
                }};
        }
    } catch (error) {
        if (response) {
            const detalle = { 
                codigo: response.codigo, 
                tipo: response.tipo, 
                renovarToken: response.codigo === 401 && response.headers.get('ErrorReason') === 'TokenExpired' 
            };
            respuesta = { auditResponse: { 
                codigoRespuesta: response.codigo, 
                mensajeRespuesta: obtenerMensajeError(response.codigo), 
                detalle 
            }};
        }
    }

    return respuesta;
};

export const reemplazarUrlServicio = (url, arrayAtributos) => {
    let urlSalida = url
    if(arrayAtributos !== null) {
        arrayAtributos.map((atributo) => {
            let variable = `{${atributo.campo}}`
            urlSalida = urlSalida.replace(variable, atributo.valor)
            return atributo
        })
    }
    return urlSalida
}

export const agregarParametros = (url, arrayParametros) => {
    let urlSalida = url
    arrayParametros.map((parametro, index) => {
      if (index === 0) {
        urlSalida = urlSalida + '?'
      } else {
        urlSalida = urlSalida + '&'
      }
      urlSalida = urlSalida + parametro.campo + '=' + parametro.valor
      return parametro
    })
    return urlSalida
  }

export const generarCorrelativo = () => {
    return Math.random().toString().substring(2, 20)
}

export const generarTransaccionId = () => {
    return uuidv4()
}

export const getIamToken = () => {
    return localStorage.getItem('msal.idtoken')
}

export const getAccessToken = () => {
    return localStorage.getItem('access.token')
}